import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import Geral from '../../Utils/Geral';
import ErrorModal from '../ErrorModal/ErrorModal';


class ModalGerarBoleto extends Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.enviarBoletoAnexo = this.enviarBoletoAnexo.bind(this);
        this.habilitaGerarBoleto = this.habilitaGerarBoleto.bind(this);
        this._outsideRange = this._outsideRange.bind(this);
        this.primeiraVia = this.primeiraVia.bind(this);
        this.toggleBoleto = this.toggleBoleto.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);

        this.state = {
            enviarBoleto: false,
            dtVencimentoBoleto: moment().add(5, "days"),
            focused: false,
            boletoSucesso: false,
            email: this.props.orderDetails.emailSolicitante
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    enviarBoletoAnexo() {
        this.setState({ enviarBoleto: !this.state.enviarBoleto });
    }


    primeiraVia() {
        this.setState({ isLoadingBoleto: true });
        const body = { idUsuario: this.props.orderDetails.idSolicitante, dtVencimentoBoleto: moment(this.state.dtVencimentoBoleto).format(), enviarEmail: this.state.enviarBoleto, email: this.state.enviarBoleto ? this.state.email : undefined };
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.orderDetails.idPedido}/boleto`, body).then(response => {
            Geral.downloadPDF(response.data.dadosBoleto.boleto, `ebs-boleto-${this.props.orderDetails.idPedido}`)
            this.setState({ erroBoleto: false, boletoSucesso: true });
            this.props.getOrderDetails();
        }).catch(err => {
            console.log(err);
            this.setState({ erroBoleto: true })
        }).finally(() => {
            this.toggleBoleto();
        }
        );
    }

    _outsideRange(day) {
        return day.format() < moment().format();
    }

    onDateChange(date) {
        this.setState({ dtVencimentoBoleto: date })
    }
    onFocusChange(objFocused) {
        this.setState(objFocused);
    }

    habilitaGerarBoleto() {
        let desabilita;
        const _checkbox = this.state.enviarBoleto,
            _emailNulo = !this.validacaoEmail(this.state.email),
            _dtNula = this.state.dtVencimentoBoleto === null;

        if (_checkbox) {
            desabilita = _emailNulo || _dtNula;
        } else {
            desabilita = _dtNula;
        }
        return desabilita
    }

    toggleBoleto() {
        this.setState({
            modalBoleto: !this.state.modalBoleto,
            isLoadingBoleto: false,
            enviarBoleto: false,
            dtVencimentoBoleto: moment().add(5, "days"),
            focused: false,
        });
    }

    validacaoEmail(inputEmail) {
        if (!inputEmail) {
            return false;
        }
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    render() {
        const {
            isOpen,
            toggleBoleto,
            orderDetails
        } = this.props;

        return (
            <Modal isOpen={isOpen} toggle={toggleBoleto}>
                <ModalHeader toggle={toggleBoleto}>Boleto</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div className="row no-gutters align-items-center">
                                <div className="col-4">
                                    <label className="m-0">Data de vencimento:</label>
                                </div>
                                {!moment(orderDetails.dtVencimentoBoleto).isValid() ? (
                                    <div className="col-3">
                                        <SingleDatePicker
                                            date={this.state.dtVencimentoBoleto !== null ? moment(this.state.dtVencimentoBoleto) : null} // momentPropTypes.momentObj or null
                                            onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                            focused={this.state.focused} // PropTypes.bool
                                            onFocusChange={({ focused }) => this.onFocusChange({ focused })} // PropTypes.func.isRequired
                                            id="your_unique_id" // PropTypes.string.isRequired,
                                            orientation="horizontal"
                                            anchorDirection="right"
                                            openDirection="down"
                                            verticalHeight={450}
                                            numberOfMonths={1}
                                            small={true}
                                            phrases={this._phrases}
                                            placeholder=""
                                            isOutsideRange={this._outsideRange}
                                        />
                                    </div>
                                ) : (
                                    <div className="col-3">
                                        {moment(orderDetails.dtVencimentoBoleto).format("DD/MM/YYYY")}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-12">
                            <input type="checkbox" className="check-box" id="enviarCopiaBoleto" style={{ marginTop: 20 }} onChange={this.enviarBoletoAnexo} checked={this.state.enviarBoleto} />
                            <label style={{ marginLeft: 7 }} htmlFor="enviarCopiaBoleto">enviar cópia do boleto por email</label>
                        </div>
                        {this.state.enviarBoleto && (
                            <div className="col-12">
                                <label>Email</label>
                                <input type="email" className="form-control" required id="email" placeholder="" value={this.state.email} name="email" onChange={this.handleInputChange} autoComplete="off" />
                            </div>
                        )}
                        {(this.state.erroEmail && this.state.enviarBoleto) && (
                            <div className="col-12">
                                <span className="text-danger">Não foi possível enviar o e-mail.</span>
                            </div>
                        )}

                        {(this.state.emailEnviado) && (
                            <div className="col-12">
                                <span className="text-primary">E-mail enviado com sucesso.</span>
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleBoleto}>cancelar</Button>
                    {' '}
                    {this.state.isLoadingBoleto ? (
                        <div className="spinner-border text-primary" role="status" />
                    ) : (
                        <Button disabled={this.habilitaGerarBoleto()} color="success" onClick={this.primeiraVia}>confirmar</Button>
                    )}
                    <div className='col-12 text-center text-primary'>
                        {this.state.boletoSucesso && (
                            <i><p className='m-0'>Boleto gerado com sucesso!</p></i>
                        )}
                    </div>
                </ModalFooter>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </Modal >
        )
    }
}

export default ModalGerarBoleto;